// Provider slug → display label + legacy icon lookup.
//
// This file keeps the small `PROVIDER_LABEL` map + a legacy `PROVIDER_ICON`
// map for backward compatibility. All NEW rendering should use the
// `ProviderBrand` component (`./ProviderBrand.js`), which layers:
//   1. local SVG in `ui/src/assets/providers/{slug}.svg`
//   2. simple-icons npm package
//   3. BDS BrandLogos
//   4. generic BDS icon fallback
//
// See `ui/src/assets/providers/README.md` for how to add real brand
// assets for the slugs where simple-icons has no logo.

import {
    Robot,
    Brain,
    AiAlt,
    Rocket,
    Storage,
    HelpOutline,
    ErrorOutline,
} from '@barracuda-internal/bds-core/dist/Icons/Core';

// Extractor emits one of these; the map is intentionally a superset so
// dormant slots light up automatically once the backend learns to
// distinguish more providers (OpenAI-compatible endpoints etc.).
export const PROVIDER_LABEL = {
    // Real detection today
    openai:       'OpenAI',
    anthropic:    'Anthropic',
    claude:       'Claude',
    gemini:       'Gemini',
    // Consumer sub-brands (same wire as the parent)
    chatgpt:      'ChatGPT',
    copilot:      'GitHub Copilot',
    // Dormant — extractor doesn't emit these yet, but the UI is future-proof
    mistralai:    'Mistral',
    meta:         'Meta / Llama',
    perplexity:   'Perplexity',
    groq:         'Groq',
    deepseek:     'DeepSeek',
    xai:          'xAI / Grok',
    ollama:       'Ollama',
    openrouter:   'OpenRouter',
    replicate:    'Replicate',
    // Enterprise wrappers
    azure_openai: 'Azure OpenAI',
    amazon:       'AWS Bedrock',
    cohere:       'Cohere',
    together:     'Together AI',
    fireworks:    'Fireworks AI',
    // Diagnostic fallbacks emitted by the extractor
    unknown:      'Unknown',
    json_parse:   'Malformed',
};

/** Slugs the ScanFilters "Provider" widget should offer as options. */
export const VALID_PROVIDERS = Object.keys(PROVIDER_LABEL);

// Legacy icon map — used by callers that still render a plain BDS Icon
// rather than the ProviderBrand component. Prefer ProviderBrand in new code.
export const PROVIDER_ICON = {
    openai:       Robot,
    anthropic:    Brain,
    claude:       Brain,
    gemini:       AiAlt,
    chatgpt:      Robot,
    copilot:      Robot,
    mistralai:    AiAlt,
    meta:         Brain,
    perplexity:   AiAlt,
    groq:         Rocket,
    deepseek:     Brain,
    xai:          Rocket,
    ollama:       AiAlt,
    openrouter:   AiAlt,
    replicate:    AiAlt,
    azure_openai: Storage,
    amazon:       Storage,
    cohere:       Brain,
    together:     AiAlt,
    fireworks:    Rocket,
    unknown:      HelpOutline,
    json_parse:   ErrorOutline,
};

export function providerLabel(p) {
    return PROVIDER_LABEL[p] ?? PROVIDER_LABEL.unknown;
}

export function providerIcon(p) {
    return PROVIDER_ICON[p] ?? PROVIDER_ICON.unknown;
}
